import { QueryClient } from "@tanstack/react-query";

/**
 * The app's QueryClient. Mutations use networkMode "always": by default React Query pauses a mutation
 * while the browser is offline, which stops the logbook's own offline queue (services/api.ts writeOrQueue)
 * from ever running and loses the entry on reload. With "always" the write is attempted, and when the
 * server cannot be reached it is stored in the durable queue (or fails with a clear error).
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 1,
      },
      mutations: {
        networkMode: "always",
        onError: (error: Error) => {
          // Global fallback: show error if no per-mutation onError handles it
          alert(error.message || "An unexpected error occurred");
        },
      },
    },
  });
}
